<div class="form-group">
  <label for="prod-m">{{ 'attributeManagement.label.key'| translate }}</label>
  <angular2-multiselect [data]="keysList"
      [(ngModel)]="keySelected"
      [settings]="multiselectSettings_base"
      (onSelect)="onKeySelect()">
  </angular2-multiselect>
</div>